(ns frontend.view.modals.delete-confirmation.check-usage-view
  (:require
   [common.localization :as loc]
   [frontend.view.modals.delete-confirmation.event :as event]
   [frontend.view.modals.delete-confirmation.sub :as sub]
   [re-frame.core :as rf]
   [ui.color :as c]
   [ui.components.alert.view :as alert]
   [ui.components.input.checkbox :as checkbox]
   [ui.components.modal.view :as modal]))

(defonce modal-key :delete-confirmation-check-usage-modal)

(defn loading-body
  []
  [:div
   {:class "py-8 flex flex-col gap-4 items-center justify-center"}
   [:svg
    {:class   "animate-spin h-8 w-8 mr-3 text-base-light-text fill-[#fff]"
     :viewBox "0 0 24 24"}
    [:circle
     {:class "opacity-75" :cx "12" :cy "12" :r "10" :stroke "currentColor" :stroke-width "4"}]
    [:path
     {:class "opacity-75" :fill "currentColor" :d "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"}]]
   (loc/tr :checking-usage)])

(defn error-body
  [error close!]
  [alert/danger
   {}
   error])

(defn conflicts-body
  [conflicts text]
  [:div
   {:class "flex flex-column gap-2"}
   [:p (or text (loc/tr :survey-block-delete-used-in-templates))]
   [:ul
    {:class "flex flex-column gap-2"}
    (->> conflicts
         (map (fn [[id display-str]]
                ^{:key (str ::conflict "-" id)}
                [:li
                 {:class "flex flex-row gap-1 items-center text-semibold"}
                 [:i.fal.fa-angle-right]
                 [:span
                  display-str]]))
         (doall))]])

(defn body
  [{:keys [body-caution body] :as props}]
  (let [confirmed? @(rf/subscribe [::sub/confirmed?])]
    [:div
     {:class "py-4 flex flex-col gap-4"}
     [:p
      (if (string? body)
        [:strong
         {:class "font-bold"}
         body]
        body)]
     (when body-caution
       [alert/warning
        {}
        body-caution])
     [:div
      [:label
       {:class "inline-flex gap-3 items-center cursor-pointer"}
       [checkbox/view
        {:value     confirmed?
         :on-change (fn [_]
                      (rf/dispatch [::event/set-confirmed? (not confirmed?)]))}]
       [:span
        (loc/tr :i-understand-theres-no-undo-for-this)]]]]))

(defn footer
  [close!]
  (let [confirmed? @(rf/subscribe [::sub/confirmed?])]
    [:<>
     [modal/left-cancel-only close! nil]
     [modal/right-single-button
      ::c/danger
      (not confirmed?)
      (fn [_]
        (rf/dispatch [::event/disable! close!]))
      (loc/tr :delete)
      nil]]))

(defn view
  [{:keys [_shown? close-modal! _topmost? props]}]
  (let [close! (fn [_]
                 (rf/dispatch [::event/cleanup])
                 (close-modal!))]
    (rf/dispatch [::event/init (:entity-id props)])
    (fn [{:keys [shown? close-modal! topmost? props]}]
      (let [{:keys [on-delete!]} props
            loading? @(rf/subscribe [::sub/loading?])
            error @(rf/subscribe [::sub/error])
            conflicts @(rf/subscribe [::sub/conflicts])]
        [modal/view
         {:visible?      (and shown? topmost?)
          :hide!         close!
          :backdrop      "static"
          :close-button? true}
         (loc/tr :attention)
         (cond loading?
               [loading-body]
               conflicts
               [conflicts-body conflicts (:conflicts-text props)]
               error
               [error-body error]
               :else
               [body props])
         (when (and (not loading?)
                    (not error))
           [footer close!])]))))
